import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React from 'react';

interface NumberStepsProps {
  step: number;
  titles: string[];
}

const NumberSteps = ({ step, titles }: NumberStepsProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        width: '100%',
        padding: '2rem 0 1rem',
        gap: '0.3rem',
      }}
    >
      {titles.map((title, index) => {
        const stepNumber = index + 1;
        return (
          <React.Fragment key={`step-fragment-${stepNumber}`}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.5rem',
                width: '90px',
                flexShrink: 0,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  padding: '0.2rem',
                  backgroundColor:
                    step >= stepNumber ? theme.palette.primary.main : theme.palette.grey[600],
                  color: 'white',
                  borderRadius: '50%',
                  width: '1.8rem',
                  textAlign: 'center',
                }}
              >
                {stepNumber}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: theme.palette.grey[600],
                  textAlign: 'center',
                  fontSize: '0.75rem',
                  lineHeight: '1.2',
                }}
              >
                {title}
              </Typography>
            </Box>
            {index < titles.length - 1 && (
              <Divider
                orientation="horizontal"
                sx={{
                  marginTop: '1rem',
                  width: '30px',
                  flexShrink: 0,
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default NumberSteps;
